import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AbstractButtonComponent } from '../abstract-button.component';
@Component({
    selector: '[inlineButton]',
    templateUrl: 'inline-button.html',
    styleUrls: ['inline-button.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineButtonComponent extends AbstractButtonComponent {
    protected variantInputName = undefined;

    // just to use [inlineButton] selector
    @Input()
    inlineButton?: any;

    @Input()
    @HostBinding('class._line')
    buttonLine = true;
}
